import React from 'react'
import { useTutorNoShow } from '../TutorNoShowContext'
import InformationBarComponent from '@common/livekit/components/InformationBarComponent'
import { theme } from '@common/theme/theme'

/**
 * Waiting bar for miniMode (student working on activities)
 * Only shows waiting message when student is waiting for tutor
 */
export function MiniModeWaitingBar() {
    const context = useTutorNoShow()

    // Guard: return null if provider is not present (e.g., trial sessions)
    if (!context) return null

    const { shouldShowBanner, waitingMessage } = context

    if (!shouldShowBanner) return null

    return (
        <InformationBarComponent
            isWaitingForTutor={true}
            waitingMessage={waitingMessage}
            bgColor={theme.colors.warning}
        />
    )
}
